module.exports = __webpack_public_path__ + "static/media/oude.965053db.png";